// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import App from './App';
import router from './router';
import store from './store';
import filters from './filters';
import mixin from './mixin';
import {EventBus} from './EventBus';
import api from './api';

import Vue from 'vue';
import {sync} from 'vuex-router-sync';
import BootstrapVue from 'bootstrap-vue';
import VueI18n from 'vue-i18n';
import Toasted from 'vue-toasted';
import VueAxios from 'vue-axios';

import MaskedInput from 'vue-text-mask';
import {DatePicker, Select, Option, Transfer, Message, MessageBox, Checkbox, Pagination, Button, CheckboxGroup, Input, Loading, Steps, Step, Popover} from 'element-ui';
import tr from 'element-ui/lib/locale/lang/tr-TR';
import en from 'element-ui/lib/locale/lang/en';
import VueUploadComponent from 'vue-upload-component';
import VueProgressBar from 'vue-progressbar';
import Notifications from 'vue-notification';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

// Custom styling
import '@/assets/scss/main.scss';

import VueTable from './components/Table';
import Spinner from './components/Spinner';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip);
Vue.use(VueI18n);
Vue.use(VueAxios, api);
Vue.use(BootstrapVue);
Vue.use(Notifications);

Vue.use(Toasted, {
    position: 'top-center',
    duration: 3000,
    theme: 'outline'
});

import locale from 'element-ui/lib/locale';

// language locale item configuration should be generic for all languages.

if (!localStorage.getItem('locale')) {
    /* let userLang = navigator.language || navigator.userLanguage;
    let userLocale = userLang === 'tr-TR' ? 'tr' : 'en';
    let userLocale = 'tr'; */
    let userLang = navigator.language || navigator.userLanguage;
    let userLocale = userLang === 'tr-TR' ? 'tr' : 'en';
    console.log('userLang', userLang);
    console.log('userLocale', userLocale);
    //let userLocale = 'en';
    localStorage.setItem('locale', userLocale);
}
store.state.locale = localStorage.getItem('locale');

if (store.state.locale === 'tr') {
    locale.use(tr);
} else {
    locale.use(en);
}
Vue.use(DatePicker, {locale});
Vue.use(Select, {locale});
Vue.use(Option, {locale});
Vue.use(Transfer, {locale});

Vue.use(Checkbox, {locale});
Vue.use(Pagination, {locale});
Vue.use(Button, {locale});
Vue.use(CheckboxGroup, {locale});
Vue.use(Input, {locale});
Vue.use(Loading, {locale});
Vue.use(Step, {locale});
Vue.use(Steps, {locale});
Vue.use(Popover, {locale});

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
for (let key in filters) {
    Vue.filter(key, filters[key]);
}

const i18n = new VueI18n({
    locale: store.state.locale,
    messages: {
        tr: {}
    }
});

Vue.use(VueProgressBar, {
    color: '#007bff',
    failedColor: '#874b4b',
    thickness: '2px',
    transition: {
        speed: '0.3s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top'
});

Vue.component('masked-input', MaskedInput);
Vue.component('file-upload', VueUploadComponent);
Vue.component('vue-table', VueTable);
Vue.component('spinner', Spinner);

Vue.config.productionTip = false;

sync(store, router);

Vue.mixin(mixin);

Vue.prototype.$eventHub = EventBus;

/* eslint-disable no-new */
new Vue({
    i18n,
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js